import debug from 'debug';

export const logAnalytics = () => ({
    error: debug('analytics:error'),
    log: debug('analytics:info'),
});
